import { render, staticRenderFns } from "./DetailCard.vue?vue&type=template&id=0f26e370"
import script from "./DetailCard.vue?vue&type=script&lang=js"
export * from "./DetailCard.vue?vue&type=script&lang=js"
import style0 from "./DetailCard.vue?vue&type=style&index=0&id=0f26e370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports